import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm2,12a2,2,0,1,1-2-2A2,2,0,0,1,14,12Zm6.82-2.13L16.12,11a.2.2,0,0,1-.18,0,.19.19,0,0,1-.09-.14,3.29,3.29,0,0,0-2.67-2.67A.19.19,0,0,1,13,8.06a.2.2,0,0,1,0-.18l1.12-4.7a.43.43,0,0,1,.52-.33,8.69,8.69,0,0,1,6.5,6.5A.43.43,0,0,1,20.82,9.87ZM3.18,14.13,7.88,13a.2.2,0,0,1,.18,0,.19.19,0,0,1,.09.14,3.29,3.29,0,0,0,2.67,2.67.19.19,0,0,1,.14.09.2.2,0,0,1,0,.18l-1.12,4.7a.43.43,0,0,1-.52.33,8.69,8.69,0,0,1-6.5-6.5A.43.43,0,0,1,3.18,14.13Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }